// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~views/colors.css\"","easilBlack":"#2c2e2f","upload":"style_upload__3yHjb","fontDropZone":"style_fontDropZone__3gd8w","checkbox":"style_checkbox__3X5Pg"};